export default __webpack_public_path__ + "sails.64f82f6f.png";